import React, { useEffect, useState, useRef, useCallback } from 'react'
import { Link } from "react-router-dom";
import axios from "axios";
import PropertyCard from "./propertycard";
import { useLocation } from 'react-router-dom';
import Carousel from './carousel';
import Youtubeembed from "../components/youtubeembed";
import iony from "../assect/images/iony.svg";
import shs from "../assect/images/shs.png";
import rensco from "../assect/images/rensco.svg";
import downtown from "../assect/images/downtown.png";
const embedId = "jjJ8Sd9RWPQ";
// const embedId2 = "QWPehrvUhmg";
const embedId2 = "XWUEv2yvg5g";
const rentalOptions = [
    {
        rentalType: 0,
        rentalTypeDisplay: 'Unfurnished',
        searchParam: 'U'
    },
    {
        rentalType: 1,
        rentalTypeDisplay: 'Furnished',
        searchParam: 'F'
    },
    {
        rentalType: 2,
        rentalTypeDisplay: 'Semi-Furnished',
        searchParam: 'SF'
    }
];

export default function AvailableProperties() {
    const location = useLocation();
    const [properties, setProperties] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [pageSize, setPageSize] = useState(4)
    const [isLoading, setIsLoading] = useState(false);

    // const apiPath = `${process.env.REACT_APP_API_URL}api/DimoraProperties/search`;
    const apiPath = `${process.env.REACT_APP_API_URL}api/Properties/search`;

    const fetchData = useCallback(async (page) => {
        if (isLoading || !hasMore) return;

        setIsLoading(true);
        try {
            // const payload = {
            //     rentalType: "F",
            //     location: "",
            //     bedrooms: 0,
            //     bathrooms: 0,
            //     availability: 1,
            //     sortBy: 3,
            //     sortDescending: true,
            //     pageSize, // Smaller page size for pagination
            //     pageNumber: page
            // }

            const payload = {
                location: "",
                available: true,
                rentalType: 1,
                page,
                pageSize,
                sortBy: "availableDt",
                sortOrder: "asc"
            }

            const response = await axios.post(apiPath, payload);
            const newProperties = response.data.properties;

            if (newProperties.length < pageSize) {
                setHasMore(false);
            }

            if (newProperties.length > 0) {
                if (page === 1) {
                    // First page - replace properties
                    setProperties(newProperties);
                } else {
                    // Subsequent pages - append properties
                    setProperties(prev => [...prev, ...newProperties]);
                }
                setPageNumber(prev => prev + 1);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }, [isLoading, hasMore, pageSize, apiPath]);

    const handleLoadMore = useCallback(() => {
        fetchData(pageNumber);
    }, [fetchData, pageNumber]);

    useEffect(() => {
        // Reset state and fetch initial data
        setProperties([]);
        setPageNumber(1);
        setHasMore(true);
        fetchData(1);
    }, []); // Empty dependency array to run only once

    return (
        <>
            <div className="align-items-center"> <p className='sub_heading sub_heading_small'>AVAILABLE PROPERTIES</p></div>
            <div className="row mt-0 justify-content-center">
                <Carousel
                    properties={properties}
                    onLoadMore={handleLoadMore}
                    hasMore={hasMore}
                    isLoading={isLoading}
                    currentPage={pageNumber}
                />
                <div className="col-lg-12 d-flex justify-content-center mt-4">
                    <Link
                        to="/PropertyListing"
                        className="btn rounded-pill px-4 py-2 fw-bold text-white scale_hover"
                        style={{
                            backgroundColor: 'rgb(182, 87, 65)',
                            '--bs-btn-hover-bg': 'rgb(100, 70, 50)',
                            '--bs-btn-active-bg': 'rgb(140, 60, 40)'
                        }}
                    >
                        View all properties
                    </Link>
                </div>

                <section className="section-50 pb-0">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12">
                                <p className="mb-md-5 mb-sm-3 sub_heading">Discover Troy</p>
                                <div className="p-0">
                                    <div className="row align-items-center justify-content-center g-4">
                                        <div className="col-xl-8">
                                            <div className="d-flex flex-md-row flex-column gap-sm-4 gap-2">
                                                <div className="card_custom w-100">
                                                    <Youtubeembed embedId={embedId} />
                                                </div>
                                                <div className="card_custom w-100">
                                                    <Youtubeembed embedId={embedId2} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-8">
                                            <ul className="d-flex gap-3 list-unstyled website_logo">
                                                <li><a href="https://www.iloveny.com/places-to-go/capital-saratoga/" target="_blank"><img src={iony} className="img-fluid" /></a></li>
                                                <li><a href="https://home.shakerheritage.org/history-watervliet/" target="_blank"><img src={shs} className="img-fluid" /></a></li>
                                                <li><a href="https://www.renscochamber.com/living-here/discover-troy/" target="_blank"><img src={rensco} className="img-fluid" /></a></li>
                                                <li><a href="https://www.downtowntroyny.org/" target="_blank"><img src={downtown} className="img-fluid" /></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}